import { Box, Button, Modal, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

export const Model_1 = ({ open, setOpen, data, children }) => {
    const navigate = useNavigate()
    const handleClose = () => setOpen(false);
    const handleButtonClick = (link, fn, cancel) => {
        if (fn) {
            fn();
        }
        if (cancel) {
            setOpen(false);
        }
        if (link) {
            navigate(link);
        }
    };
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: '83%', md: "537px" },
        bgcolor: "#FFFFFF",
        // border: '2px solid #000',
        boxShadow: 24,
        outlineColor: "invert",
        p: 2,
        ...(data?.outBoxStyle ? { ...data?.outBoxStyle } : {})
    };
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {children}
            </Box>
        </Modal>
    );
};
